module.exports = {"name":"viaccessorca","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.0","built":"2018-06-05","repo":"https://bitbucket.org/npaw/viaccessorca-adapter-js","libVersion":"6.2.6","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getPlayrate","getDroppedFrames","getDuration","getBitrate","getRendition","getTitle","getIsLive","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 29
// module chunks = 0